import React from 'react';
import { TripInfo } from '../../types/Quotation';
import PDFHeader from './PDFHeader';

const formatDuration = (minutes?: number) => {
  if (minutes === undefined) return '';
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return hours > 0 ? `${hours}h${remainder ? ` ${remainder}m` : ''}` : `${remainder}m`;
};

const PDFRouteTransfers: React.FC<{ tripInfo: TripInfo; renderedAt?: string; embedded?: boolean }> = ({ tripInfo, renderedAt, embedded = false }) => {
  const legs = Array.isArray(tripInfo.routeLegs) ? tripInfo.routeLegs : [];
  const hasDetails = legs.some((leg) => leg.distanceKm !== undefined || leg.durationMinutes !== undefined || leg.transferNote);
  if (!hasDetails || tripInfo.places.length < 2) return null;

  const content = <section className={embedded ? 'pdf-route-transfers pdf-keep-together' : 'pdf-section'}>
      <h2>Route &amp; Transfers</h2>
      <p className="pdf-route-transfers__intro">Your journey, city by city, with the transfer details that connect each stay.</p>
      <div className="pdf-route-transfers__timeline">
        {tripInfo.places.map((place, index) => {
          const leg = legs.find((item) => item.fromStopIndex === index && item.toStopIndex === index + 1);
          const hasLegDetails = Boolean(leg && (leg.distanceKm !== undefined || leg.durationMinutes !== undefined || leg.transferNote));
          return <div className="pdf-route-transfers__entry" key={`${place.label}-${index}`}>
            <div className="pdf-route-transfers__stop">
              <div className="pdf-route-transfers__marker">{index + 1}</div>
              <div className="pdf-route-transfers__city">
                <strong>{place.label}</strong>
                <span>{place.nights} night{place.nights === 1 ? '' : 's'} stay</span>
              </div>
            </div>
            {index < tripInfo.places.length - 1 && (
              <div className="pdf-route-transfers__connector">
                <div className="pdf-route-transfers__line" />
                {hasLegDetails && <div className="pdf-route-transfers__transfer">
                  <span className="pdf-route-transfers__transfer-label">Transfer</span>
                  {leg?.transferNote && <strong>{leg.transferNote}</strong>}
                  <div className="pdf-route-transfers__metrics">
                    {leg?.distanceKm !== undefined && <span>{leg.distanceKm} km</span>}
                    {leg?.durationMinutes !== undefined && <span>{formatDuration(leg.durationMinutes)}</span>}
                  </div>
                </div>}
              </div>
            )}
          </div>;
        })}
      </div>
    </section>;

  if (embedded) return content;
  return <div className="pdf-page"><PDFHeader renderedAt={renderedAt} />{content}</div>;
};

export default PDFRouteTransfers;
